import React, { useEffect, useState } from 'react';
import { Spinner, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useLazyGetTanProfilesQuery, useLazyGetComponentsQuery, useDeleteSessionProfileMutation } from '../../redux/services/tanProfilesApi';
import { useDispatch, useSelector } from 'react-redux';
import { setProfileMeta, setSelected } from '../../redux/slice/tanProfileSlice';
import { useTranslation } from 'react-i18next';
import sadImage from "../../assets/images/sad.png";
import { slice_map } from '../../components/componentMap/componentMap';
import {
    SwipeableList,
    SwipeableListItem,
    SwipeAction,
    TrailingActions,
} from 'react-swipeable-list';
import 'react-swipeable-list/dist/styles.css';
import "./SwipeableProfileList.css"

const SwipeableProfileList = ({
    deleteable = false,
    bypassEdit = false,
    top = null
}) => {
    const { t } = useTranslation("translation", { keyPrefix: "tanProfiles" });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const itemsPerPage = 500;
    const [page, setPage] = useState(1);
    const profileMeta = useSelector((state) => state?.tanProfile?.profileMeta);

    const profileData = useSelector((state) => state?.tanProfile?.profiles);
    const componentData = useSelector((state) => state?.tanProfile?.components);
    const mappedComponents = useSelector((state) => state?.tanProfile?.mappedComponents);
    const currentProfiles = profileData[page]?.users;

    const [getComponents] = useLazyGetComponentsQuery();
    const [getTanProfiles, { isLoading: loadingProfiles }] = useLazyGetTanProfilesQuery();
    const [deleteProfile, { isSuccess: deleted }] = useDeleteSessionProfileMutation();

    useEffect(() => {
        getComponents();
        getTanProfiles({ page, limit: itemsPerPage });
    }, [page]);

    useEffect(()=>{
        getTanProfiles({ page, limit: itemsPerPage })
    }, [deleted])

    return (
        <>
            <div className='profile-list'>
                {top}
                {loadingProfiles ? <Spinner animation="border" /> :
                    currentProfiles ? (
                        <SwipeableList>
                            {Object.keys(currentProfiles).map((i) => {
                                let clickable = true
                                let sessionComponents = [...(currentProfiles[i]?.data?.session_component || currentProfiles[i]?.data?.session_components)]
                                let pills = <></>
                                let tanRapidObj = null
                                if(sessionComponents?.length){
                                    const valueCountMap = {};
                                    sessionComponents.forEach(comp => {
                                        const vid = comp?.component_value_id;
                                        if (vid != null) valueCountMap[vid] = (valueCountMap[vid] || 0) + 1;
                                    });
                                    const seenValueIds = new Set();
                                    pills = Object.keys(sessionComponents).map((j) => {
                                        const component_value_id = sessionComponents[j]?.component_value_id;
                                        if (seenValueIds.has(component_value_id)) return null;
                                        seenValueIds.add(component_value_id);

                                        let component_id = sessionComponents[j]?.component_id;
                                        let tanRapidSwitch = component_id === 1 ? 14 : component_id === 14 ? 1 : null
                                        let component_value = sessionComponents[j]?.value;
                                        let name = componentData[component_id]?.name;
                                        let missingComp = !Object.values(mappedComponents).find((item) => item.componentId === component_id)
                                        if(missingComp && tanRapidSwitch && Object.values(mappedComponents).find((item) => item.componentId === tanRapidSwitch)){
                                            if(component_value < 13){
                                                tanRapidObj = {component_id: component_id, value: component_value, swap_id: tanRapidSwitch }
                                                missingComp = false //used to allow selecting tan in rapid booths and vice versa.
                                            }
                                        }
                                        if(clickable && bypassEdit && missingComp){
                                            clickable = false;
                                        }
                                        const dupLabel = valueCountMap[component_value_id] > 1 ? ' x2' : '';
                                        return name ? <Badge bg={missingComp ? "danger" : "primary"} pill key={j}>{name}: {component_value}{dupLabel}</Badge> : null;
                                    })
                                }
                                return <SwipeableListItem
                                    key={currentProfiles[i]?.id}
                                    onClick={() => {
                                        if(clickable){
                                            const hasTan = Object.values(sessionComponents).some((item) => item.component_id === 1);
                                            const hasWellfit = Object.values(sessionComponents).some((item) => item.component_id === 22);
                                            let sessionTypes = [];
                                            let sessiontype = "wellfit";
    
                                            if (hasWellfit && !hasTan) sessionTypes.push("wellfit");
                                            if (hasTan && !hasWellfit) {
                                                sessionTypes.push("tan");
                                                sessiontype = "tanSelection";
                                            }
                                            if (hasTan && hasWellfit) {
                                                sessionTypes.push("tanfit");
                                                sessiontype = "tanSelection";
                                            }
                                            let meta = { options: slice_map(mappedComponents), navigationDirection: "edit", sessionTypes }
                                            if (profileMeta?.profileType === "scanBooth") {
                                                meta.profileType = "scanBooth"
                                            }
                                            dispatch(setProfileMeta(meta));
                                            if(tanRapidObj){
                                                // This unholy mess replces the tan with rapid and vice versa
                                                let newComp = {...Object.values(componentData).find((item) => item.id === tanRapidObj.swap_id).component_values.find((compItem) => compItem.value === tanRapidObj.value)}
                                                let newCompClean = {value: newComp.value, component_id: newComp.component_id, component_value_id: newComp.id}
                                                let prevInd = sessionComponents.findIndex((item) => item.component_id === tanRapidObj.component_id)
                                                sessionComponents.splice(prevInd, 1, newCompClean)
                                            }
                                            dispatch(setSelected({
                                                session_name: currentProfiles[i]?.data.session_name,
                                                session_component: sessionComponents,
                                                id: currentProfiles[i]?.id
                                            }));
                                            bypassEdit ? navigate(`/session/confirmSession`) : navigate(`/session/${sessiontype}`)
                                        }
                                    }}
                                    trailingActions={
                                        deleteable &&
                                        <TrailingActions>
                                            <SwipeAction
                                                destructive
                                                onClick={() => {
                                                    deleteProfile({ id: currentProfiles[i]?.id })
                                                }}
                                            >
                                                <div className='delete-swipe'>
                                                    <i className='bi bi-trash'></i>
                                                </div>
                                            </SwipeAction>
                                        </TrailingActions>


                                    }
                                >
                                    <div className={"profile-item" + (clickable ? "" : " disabled")} >
                                        <div className="fw-bold profile-title">{currentProfiles[i]?.data.session_name}</div>
                                        <h5 className="pills">
                                            {pills}
                                        </h5>
                                    </div>
                                </SwipeableListItem>
                            })}
                        </SwipeableList>
                    ) : (
                        <div className='no-profiles'>
                            <img src={sadImage} alt="No profiles" className='sad-image' />
                            <p>{t("nosaved", "You have no saved tan profiles")}</p>
                        </div>
                    )
                }
            </div>
            {/* Create New Profile */}
            <div className="add-profile" onClick={() => {
                let meta = { options: slice_map(mappedComponents), navigationDirection: "new" };
                if (!bypassEdit) {
                    meta = { ...profileMeta, ...meta }
                } else {
                    dispatch(setSelected({
                        session_component: []
                    }));
                }
                if (profileMeta?.profileType === "scanBooth") {
                    meta.profileType = "scanBooth"
                }
                if (!meta?.sessionTypes?.length) {
                    meta.sessionTypes = ["tan", "wellfit", "tanfit"];
                }
                dispatch(setProfileMeta(meta));
                navigate(`/session/sessionSelection`);
            }}>
                <i className="bi bi-plus-circle-fill"></i> {t("button.addnew", "Create A New Tan Profile").toUpperCase()}
            </div>
        </>
    );
};

export default SwipeableProfileList;
